/**
 * @desc interpreterCancelRelay
 */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {}

export const method = 'POST';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey(
      '/api/bs-vmeeting/v3/meeting/interpret/interpreters/relay/cancel',
      params,
      'POST',
    ),
    newValue,
    shouldRevalidate,
  );
}

export function useDeprecatedRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest(
    '/api/bs-vmeeting/v3/meeting/interpret/interpreters/relay/cancel',
    params,
    swrOptions,
    { method: 'POST' },
  );
}

export function request(
  params: Params,
  body: defs.client.UserOperationParameters,
  options?: any,
) {
  return PontCore.fetch(
    PontCore.getUrl(
      '/api/bs-vmeeting/v3/meeting/interpret/interpreters/relay/cancel',
      params,
      'POST',
    ),
    {
      method: 'POST',

      body,
      ...options,
    },
  );
}
